export function pipeThru(init, fns) {
  return fns.reduce(
    (onion, fn) => (val) => fn(onion(val)),
    (val) => val,
  )(init);
}
